import { render, staticRenderFns } from "./balance-recharge.vue?vue&type=template&id=7363df95"
import script from "./balance-recharge.vue?vue&type=script&lang=ts"
export * from "./balance-recharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports